import { TRANSITIONS } from '@aeris/sales';
export const SALES_KIND_LABELS = {
    quote: 'Orçamento',
    order: 'Pedido',
    sale: 'Venda',
};
const TEXT = {
    draft: {
        label: 'Rascunho',
        tone: 'neutral',
        what: 'Ainda não vale para ninguém: sem número e sem efeito no estoque.',
        next: 'Enviar para o cliente.',
    },
    sent: {
        label: 'Enviado',
        tone: 'info',
        what: 'O cliente já tem o papel na mão. Ganhou número, e se foi marcado para reservar, a mercadoria está separada.',
        next: 'Esperar o cliente responder.',
    },
    accepted: {
        label: 'Aceito',
        tone: 'success',
        what: 'O cliente disse sim. Nada saiu do estoque ainda.',
        next: 'Converter em pedido.',
    },
    rejected: {
        label: 'Recusado',
        tone: 'danger',
        what: 'O cliente disse não. A reserva voltou para o estoque.',
        next: 'Recusado não se corrige: faça outro orçamento.',
    },
    expired: {
        label: 'Vencido',
        tone: 'warning',
        what: 'O prazo passou. A reserva voltou e o preço do papel não vale mais.',
        next: 'Refaça o orçamento com o preço de hoje.',
    },
    confirmed: {
        label: 'Confirmado',
        tone: 'info',
        what: 'A loja se comprometeu a entregar. A mercadoria está reservada, e ainda está aqui.',
        next: 'Dar saída quando a mercadoria sair.',
    },
    fulfilled: {
        label: 'Saiu',
        tone: 'success',
        // A frase existe porque a palavra anterior mentia: diz as duas coisas que
        // acontecem — e a terceira, a nota fiscal, que NÃO acontece.
        what: 'A mercadoria saiu da loja e o estoque foi baixado. Não emite nota fiscal.',
    },
    completed: {
        label: 'Concluído',
        tone: 'success',
        what: 'A venda terminou: o cliente levou a mercadoria e o dinheiro entrou.',
    },
    converted: {
        label: 'Convertido',
        // Verde, e não cinza (F156): cinza é o tom de "Rascunho", e o orçamento
        // parecia REGREDIR no instante em que o negócio fechava.
        tone: 'success',
        what: 'O orçamento virou pedido, levando os preços que foram prometidos. Ele fecha aqui; a vida continua no pedido.',
        next: 'Acompanhe o pedido em Vendas.',
    },
    cancelled: {
        label: 'Cancelado',
        tone: 'danger',
        what: 'Desfeito: a reserva foi liberada e a baixa estornada com movimentos novos, sem apagar os antigos.',
    },
};
/**
 * Em que tipo de documento cada situação existe, **derivado da máquina de
 * estados** — uma lista à mão divergiria na primeira transição nova.
 */
const reachableIn = (kind) => {
    const map = TRANSITIONS[kind];
    const reachable = new Set(Object.keys(map));
    for (const destinations of Object.values(map)) {
        for (const destination of destinations)
            reachable.add(destination);
    }
    return [...reachable];
};
export const STATUSES_BY_KIND = {
    quote: reachableIn('quote'),
    order: reachableIn('order'),
    sale: reachableIn('sale'),
};
const kindsOf = (status) => Object.keys(STATUSES_BY_KIND).filter((kind) => STATUSES_BY_KIND[kind].includes(status));
const ALL_KINDS = Object.keys(STATUSES_BY_KIND).length;
export const SALES_STATUS_TEXT = Object.fromEntries(Object.keys(TEXT).map((status) => {
    const kinds = kindsOf(status);
    return [
        status,
        {
            ...TEXT[status],
            ...(kinds.length < ALL_KINDS ? { onlyIn: kinds } : {}),
        },
    ];
}));
/** "só em pedido" — a parte da explicação que depende do tipo de documento. */
export const onlyInLabel = (meta, kindLabels = SALES_KIND_LABELS) => meta.onlyIn === undefined
    ? null
    : `só em ${meta.onlyIn.map((kind) => kindLabels[kind].toLowerCase()).join(' e ')}`;
/**
 * A situação que a tela mostra para UM documento (Eduardo, 16/10).
 *
 * O pedido entregue fica `fulfilled` para sempre; com o acerto feito
 * (`exchangeScope` diferente de `delivery-not-settled`), mostra "Concluído".
 * A situação gravada não muda. `settled` diz se foi esse o caso, para quem
 * precisa trocar o ícone.
 */
export const documentStatusText = (document) => {
    const meta = SALES_STATUS_TEXT[document.status];
    if (document.kind !== 'order' ||
        document.status !== 'fulfilled' ||
        document.exchangeScope === undefined ||
        document.exchangeScope === 'delivery-not-settled') {
        return { ...meta, settled: false };
    }
    return {
        ...meta,
        label: 'Concluído',
        what: 'O pedido terminou: a mercadoria saiu e o acerto foi feito.',
        settled: true,
    };
};
//# sourceMappingURL=sales.js.map